export const bioData = {
  background:
    "Hi there! I'm Dave. Thanks for checking out my site! I'm originally from the United States, but I've been living on and off in Eastern Europe for 10 years.",
  career:
    'Prior to becoming a developer, I served in the U.S. Army, then worked in a variety of contracting and consulting jobs with the U.S. DoD and Department of the Army.',
  hobbies:
    "I'm a coffee lover, amateur photographer, and someone who loves exploring Europe.",
};
